// removed by extract-text-webpack-plugin
module.exports = {"List":"_39SBX2Kei7f5n1YKAO_sDH","Header":"_1LTVDig_4XipfvNa70DhCa","green":"Yvq203WgzMBylbcJEa11r","red":"_2oN3uDiAB6yGqfr5nGSNog","Row":"_2OkHcjKYc-U5SgRWYe1UO0"};


//////////////////
// WEBPACK FOOTER
// ./src/lists/EmployeesList/index.css
// module id = 855
// module chunks = 0